module.exports = __webpack_public_path__ + "img/dlsjjkxt_bak.0db6d9ab.jpg";